import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  profile: {
    id: 'studio.G6hIMy',
    defaultMessage: 'Public profile',
  },
  title: {
    id: 'studio.itPgxd',
    defaultMessage: 'Profile',
  },
  loadEmailError: {
    id: 'studio.BTfI2K',
    defaultMessage: 'There was a problem loading your registered email addresses.',
  },
  actions: {
    id: 'studio.wL7VAE',
    defaultMessage: 'Actions',
  },
  addEmail: {
    id: 'studio.n3abN1',
    defaultMessage: 'Add an email address',
  },
  addEmailSuccess: {
    id: 'studio.BY8dgI',
    defaultMessage: 'Successfully added email address',
  },
  addEmailConflict: {
    id: 'studio.gR2hpT',
    defaultMessage: 'This email address has already been registered.',
  },
  addEmailError: {
    id: 'studio.YkBh9a',
    defaultMessage: 'Something went wrong when trying to add this email address.',
  },
  cancel: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
  deleteEmail: {
    id: 'studio.Ma2eea',
    defaultMessage: 'Remove email address',
  },
  deleteEmailSuccess: {
    id: 'studio.nW0iZ+',
    defaultMessage: 'Successfully removed email address.',
  },
  email: {
    id: 'studio.sy+pv5',
    defaultMessage: 'Email',
  },
  emails: {
    id: 'studio.AdAi3x',
    defaultMessage: 'Emails',
  },
  emailWarningTitle: {
    id: 'studio.PYHQOg',
    defaultMessage: 'Deleting email address',
  },
  emailWarning: {
    id: 'studio.KQyGdZ',
    defaultMessage: 'Are you sure you want to remove this email address?',
  },
  emailInvalid: {
    id: 'studio.jv0FOj',
    defaultMessage: 'This must be a valid email address',
  },
  emailRequired: {
    id: 'studio.KssJcX',
    defaultMessage: 'An email address is required',
  },
  displayName: {
    id: 'studio.dOQCL8',
    defaultMessage: 'Display name',
  },
  displayNameHelp: {
    id: 'studio.VL5z0t',
    defaultMessage: 'This is the name that displays for other users.',
  },
  saveProfile: {
    id: 'studio.ZBVds5',
    defaultMessage: 'Save profile',
  },
  submitSuccess: {
    id: 'studio.3zjiGZ',
    defaultMessage: 'Successfully updated profile.',
  },
  submitError: {
    id: 'studio.KB7HTt',
    defaultMessage: 'Something went wrong trying to update your profile.',
  },
  setPrimaryEmail: {
    id: 'studio.vmaAvz',
    defaultMessage: 'Set as primary',
  },
  primaryEmailSuccess: {
    id: 'studio.9IVLHM',
    defaultMessage: 'Successfully set {email} as your primary email address.',
  },
  verified: {
    id: 'studio.Z8971h',
    defaultMessage: 'Verified',
  },
  unverified: {
    id: 'studio.dXTCjA',
    defaultMessage: 'Not verified',
  },
  primary: {
    id: 'studio.t2Wr8I',
    defaultMessage: 'Primary',
  },
  preferredLanguage: {
    id: 'studio.R/13HH',
    defaultMessage: 'Preferred language',
  },
  preferredLanguageHelp: {
    id: 'studio.18cyzo',
    defaultMessage: 'The preferred language to use for the Appsemble Studio.',
  },
  timezone: {
    id: 'studio.IcUakl',
    defaultMessage: 'Time zone',
  },
  timezoneHelp: {
    id: 'studio.lQxlek',
    defaultMessage: 'The time zone used for formatting time in emails',
  },
  newsletter: {
    id: 'studio.It/Dy0',
    defaultMessage: 'Yes, I want to be kept up to date with Appsemble news.',
  },
  passwordLabel: {
    id: 'studio.5sg7KC',
    defaultMessage: 'Password',
  },
  changePassword: {
    id: 'studio.L4nXIc',
    defaultMessage: 'Change password',
  },
  currentPasswordLabel: {
    id: 'studio.NIynnB',
    defaultMessage: 'Current password',
  },
  newPasswordLabel: {
    id: 'studio.fTHhSB',
    defaultMessage: 'New password',
  },
  wrongPasswordError: {
    id: 'studio.Wl5Ylc',
    defaultMessage: 'Current password is incorrect.',
  },
  changePasswordSuccess: {
    id: 'studio.dt/e+s',
    defaultMessage: 'Successfully changed password.',
  },
});
